import { Component, Inject, PLATFORM_ID, Renderer2 } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import * as AOS from 'aos';
import { Constants } from '../../common/constants';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { SeoService } from 'src/app/common/seo.service';
@Component({
  selector: 'app-brand-messaging-blueprint',
  templateUrl: './brand-messaging-blueprint.component.html',
  styleUrl: './brand-messaging-blueprint.component.css'
})
export class BrandMessagingBlueprintComponent {

  isBrowser:boolean=false;
  baseUrl = Constants.baseUrl;

  constructor(
    private titleService: Title,  @Inject(PLATFORM_ID) private platformId: any,
    private _renderer2: Renderer2,private seoService:SeoService,
    @Inject(DOCUMENT) private _document: Document,
    private metaService: Meta
  ) {this.isBrowser=isPlatformBrowser(this.platformId);}
  ngOnInit() {
    let script = this._renderer2.createElement('script');
    script.type = `application/ld+json`;
    script.text = `
{
  "@context": "https://schema.org",
  "@type": "BlogPosting",
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://mitresource.com/brand-messaging-blueprint"
  },
  "headline": "Brand Messaging Blueprint: How to Craft a Voice That Wins Trust and Drives Growth",
  "description": "Great brands don’t just sell—they speak, connect, and stay unforgettable. Here’s our blueprint to craft a brand message that wins trust, stands out, and drives growth.",
  "image": "https://mitresource.com/assets/images/blogs/brand1.png",  
  "author": {
    "@type": "Organization",
    "name": "Maganti IT",
    "url": "https://mitresource.com/"
  },  
  "publisher": {
    "@type": "Organization",
    "name": "Maganti IT",
    "logo": {
      "@type": "ImageObject",
      "url": "https://mitresource.com/assets/images/homepage/update-mitimage.png"
    }
  },
  "datePublished": "2024-04-24"
}`;
   
    this._renderer2.appendChild(this._document.head, script);
if(this.isBrowser){     
  AOS.init({disable: 'mobile', duration: 2000, delay: 500,});
}
    this.setTitleAndMetaTags();
    this.seoService.createLinkForCanonicalURL();
  }

  scrollToSection(sectionId: string) {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  }


  private setTitleAndMetaTags(): void {
    this.titleService.setTitle('Brand Messaging Blueprint');

    this.metaService.addTags([
      { name: 'description', content: "Great brands don’t just sell—they speak, connect, and stay unforgettable. Here’s our blueprint to craft a brand message that wins trust, stands out, and drives growth." },
      { property: 'og:type', content: 'website' },
      { property: 'og:title', content: 'Brand Messaging Blueprint: How to Craft a Voice That Wins Trust and Drives Growth' },
      { property: 'og:url', content: 'https://mitresource.com/brand-messaging-blueprint/'},
      { property: 'og:image', content: 'https://mitresource.com/assets/images/blogs/brand1.png' },
      { property: 'og:description', content: 'Great brands don’t just sell—they speak, connect, and stay unforgettable. Here’s our blueprint to craft a brand message that wins trust, stands out, and drives growth.'},
    ]);
  }
}
